import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, DataService, ToastrService, UnifiedRedemptionService } from '../../../_services';
import { environment } from '../../../../environments/environment';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.css'],
    providers: [UnifiedRedemptionService]
})
export class LandingPageComponent implements OnInit {
    @ViewChild('purchaseVerfication') purchaseVerificationModal: NgbModal;
    userInfo: any;
    model: any = {};
    loading = false;
    modalReference = null;
    helpFindingType: string;
    purchaseVerificationModalRef: NgbModalRef;
    inputKeyType: string;
    untillHidden: boolean = false;
    isbnWrongQA: boolean = false;
    isKeyInvalid: boolean = false;
    isKeyUnavailable: boolean = false;
    isArchived: boolean = false;
    isServerError: boolean = false;
    redeemErrorMsg: string = '';
    qaError: string = '';

    constructor(private activatedRoute: ActivatedRoute,
        private _router: Router,
        private _dataService: DataService,
        private _authenticationService: AuthenticationService,
        private _modalService: NgbModal,
        public _toastrService: ToastrService,
        private _unifiedRedemptionService: UnifiedRedemptionService) {
    }

    ngOnInit() {
        this.userInfo = this._authenticationService.getUserInfo();

        /*Page's GA data */
        (<any>window).gtag('config', environment.gaId, { 'page_path': `/landing-page` });
    }

    redeemLicenseKey() {
        const url = '/auth/redeemLicenseKey';
        this.loading = true;
        const body = {
            'licenseKey': this.model.license_key,
            'userID': this._authenticationService.getUserID()
        };
        this._dataService.post(url, body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        (<any>window).gtag('event', 'Click', {
                            'event_category': 'Button Clicked',
                            'event_label': `License Key Redeem Button for ${this.model.license_key}`
                        });

                        this._toastrService.typeCustomSuccess(data.response_message);
                        this.loading = false;
                        this._router.navigate(['home']);
                    }
                },
                (error) => {
                    if (error.error.err_message === 'ER_DUP_ENTRY') {
                        this.isServerError = true;
                        this.redeemErrorMsg = "This account already has a Master Code associated with it.";
                         //this._toastrService.typeCustomError("This account already has a Master Code associated with it.");
                    } else {
                        this.isServerError = true;
                        this.redeemErrorMsg = (error.error.response_message || error.status_text);
                        // this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    }
                    this.loading = false;
                });
    }

    redeemISBN() {
        const body = {
            'questionAns': this.model.questionAns,
            'questionNo': this.model.question.questionNo,
            'question': this.model.question.question,
            'item_type': this.model.item_type,
            'tcm_id': this.model.tcm_id,
            'userID': this._authenticationService.getUserID()
        };

        this._dataService.post('/auth/redeemISBN', body)
            .subscribe(
                (data: { data: any, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this.purchaseVerificationModalRef.close();
                        this._toastrService.typeCustomSuccess(data.response_message);
                        this._router.navigate(['home']);
                    } else {
                        this.purchaseVerificationModalRef.close();
                        this._toastrService.typeCustomError(data.response_message);
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    this._toastrService.dismissToastOnClick(error.error.response_message || error.status_text);
                });
    }

    verifyISBNAnswer() {
        const body = {
            'questionAns': this.model.questionAns,
            'questionNo': this.model.question.questionNo,
            'question': this.model.question.question,
            'item_type': this.model.item_type,
            'tcm_id': this.model.tcm_id,
            // 'userID': this._authenticationService.getUserID()
        };

        this.isbnWrongQA = false;

        this._dataService.post('/landingpage/verifyAnswer', body)
            .subscribe(
                (data: { data: any, response: string, response_message: string }) => {
                    if (data.response === 'success') {
                        this._toastrService.typeCustomSuccess(data.response_message);
                        this.model.question = this.model.question.questionNo;     // To avoid stringifying inner {}.
                        this._router.navigate(['login'], {
                            queryParams:
                                { redemptionParams: JSON.stringify(this.model) }
                        });
                    } else {
                        // TODO - show error
                        this.isbnWrongQA = true;
                        this.qaError = data.response_message;
                        // this._toastrService.typeCustomError(data.response_message);
                    }
                },
                (error) => {
                    this.isbnWrongQA = true;
                    this.qaError = ((error.error || {}).response_message || error.status_text);
                    // this._toastrService.typeCustomError((error.error || {}).response_message || error.status_text);
                    // this._toastrService.dismissToastOnClick((error.error || {}).response_message || error.status_text);
                });
    }

    // purchaseVerficationModal(purchaseVerfication) {
    //   this._modalService.open(purchaseVerfication);
    // }


    curriculumKitModal(curriculumKit) {
        this._modalService.open(curriculumKit);

        (<any>window).gtag('event', 'Click', {
            'event_category': 'Button Clicked',
            'event_label': `Link Button for 'Need help deciding what you\'re redeeming?'`
        });
    }

    helpFindingModal(helpFinding, type) {
        this.helpFindingType = type;
        this.modalReference = this._modalService.open(helpFinding);
    }

    digitalKeychange(val) {
        let value = val;
        const lastchar = value.substr(value.length - 1).replace(/\s/g, "");
        if (!(new RegExp('^[a-zA-Z0-9]+$').test(lastchar))) {
            value = value.substr(0, value.length - 1);
            val = value;
        }

        let chIbn = value.replace(/\s/g, "").toUpperCase().split('-').join('');
        if (chIbn.length > 0) {
            chIbn = chIbn.match(new RegExp('.{1,4}', 'g')).join('-');
        }
        this.model.license_key = chIbn;
    }

    close() {
        this.modalReference.close();
    }

    async startRedemption(redeemForm: NgForm): Promise<any> {
        
        const input = this.model.inputKey || '';
        if (!input) {

            redeemForm.reset();
            return;
        }

        let output = await this._unifiedRedemptionService.identifyInputKey(input),
            data = ((output || {}).data || {});

        // console.log(`Input Key is a ${data.keyType}`);
        if (!!(output || {}).error) {
            // show error message here
            console.error(output.error.message || output.error);
            this.isServerError = true;
            this.isKeyInvalid = false;
            this.isKeyUnavailable = false;
            this.isArchived = false;
            this.redeemErrorMsg = (output.error.message || output.error);
            return;
        } else if (data.keyStatus == 'not_available') {
            // } else if (data.keyStatus !== 'available' && data.keyId > 0) {
            // Key is not available to redeem / already consumed.
            this.isKeyUnavailable = true;
            this.isServerError = false;
            this.isKeyInvalid = false;
            this.isArchived = false;
            return;
        } else if ((data.keyId === null && data.keyStatus === 'key_not_found') || (data.keyId === null && data.keyType === 'invalid_key')) {
            this.isKeyInvalid = true;
            this.isServerError = false;
            this.isKeyUnavailable = false;
            this.isArchived = false;
            return;
        }else if ((data.keyStatus === 'archived')) {
            this.isArchived = true;
            this.isKeyInvalid = false;
            this.isServerError = false;
            this.isKeyUnavailable = false;
            return;
        } else if ((data.keyType == 'license_key' || data.keyType == 'master_code_key') && data.keyStatus == 'available') {
            this.model.license_key = this.model.inputKey;
            this.model.isbn_key = null;
            // this.untillHidden = true;
            this._router.navigate(['login'], {
                queryParams:
                    { redemptionParams: JSON.stringify({ "key": input, "keyId": data.keyId, "keyType": data.keyType, "keyStatus": data.keyStatus }) }
            });

        } else if (data.keyType == 'isbn') {
            this.model.isbn_key = this.model.inputKey;
            this.model.license_key = null;
            this.model = { ...(JSON.parse(JSON.stringify(data))), ...this.model };
            this.untillHidden = true;

            (<any>window).gtag('event', 'Click', {
                'event_category': 'Button Clicked',
                'event_label': `ISBN Redeem Button for ${this.model.isbn_key}`
            });
        }
    }

    resetQAForm(form: NgForm) {
        this.untillHidden = false;
        form.reset();
        this.isbnWrongQA = false;
        this.qaError = '';
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/login/landing-page/landing-page.component.ts